import React from 'react'
import AutoComplete from 'material-ui/AutoComplete';
import Chip from 'material-ui/Chip';

const mainRole = 'owner'

function withExclusions(getData, Component) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                exclusionsData: [],
                currentExcl: {_id: '', name: ''}
            }
            this.changeAutoComplete = this.changeAutoComplete.bind(this);
            this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
            this.renderRestrictions = this.renderRestrictions.bind(this);
            this.handleRequestDelete = this.handleRequestDelete.bind(this);
        }
        changeAutoComplete(searchText) {
            this.setState({
                exclusionsData: [],
                currentExcl: {
                    ...this.state.currentExcl,
                    name: searchText,
                }
            }, () => {
                if (searchText.length >= 2) {
                    getData(searchText)
                        .then((response) => {
                            if (response.status === 200) {
                                const exclusions = response.data.data.map(exclusion => ({
                                    ...exclusion,
                                }));
    
                                if (!exclusions.length) {
                                    this.setState({
                                        exclusionsData: [],
                                        currentExcl: {
                                            ...this.state.currentExcl,
                                            name: searchText,
                                        }
                                    });
                                } else {
                                    this.setState({
                                        exclusionsData: exclusions,
                                    });
                                }
                            }
                        })
                        .catch((error) => {
                            console.error('Error AutoComplete Trading Restrictions - Trading Restrictions component', error);
                            return null;
                        });
                }
            });
        }
        chooseAutoComplete(type, updateProperties) {
            if (!updateProperties || !updateProperties._id) return;
            
            this.setState({
                exclusionsData: [],
                currentExcl: {
                    ...this.state.currentExcl,
                    name: '',
                }
            });
            if (this.props[type].find(excl => excl._id === updateProperties._id)) {
                console.log(this.props[type].find(excl => excl._id === updateProperties._id), updateProperties);
                return;
            };
            this.props.changeField({
                field: type,
                value: [...this.props[type], updateProperties],
            });
        }
        handleRequestDelete(type, excl) {
            let newRestrictions = this.props[type].filter(restriction => {
                if (restriction._id === excl._id) {
                    if (restriction.role === excl.role) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else {
                    return true;
                }
            });
            this.props.changeField({
                field: type,
                value: newRestrictions,
            });
        } 
        renderRestrictions(type) {
            return this.props[type].map(excl => {
                const ownersExcl = excl.role === mainRole;
                const canDelete = (ownersExcl && this.props.deleteOwners) || !ownersExcl;
                return (
                    <Chip
                        //onRequestDelete={!ownersExcl ? () => this.handleRequestDelete(type, excl._id) : null}
                        onRequestDelete={canDelete ? () => this.handleRequestDelete(type, excl) : null}
                        labelStyle={{ maxWidth: canDelete ? 'calc(100% - 24px)' : '', display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        style={{ margin: 4, maxWidth: '100%' }}
                        key={excl._id + excl.role}
                        backgroundColor={ownersExcl ? '#E6E6E6' : '#D6EDBD'}
                    >
                        {excl.name}
                    </Chip>
                )
            })
        }
        render() {
            const {renderRestrictions, handleRequestDelete, chooseAutoComplete, changeAutoComplete} = this;
            const {exclusionsData, currentExcl} = this.state;
            return <Component dataSource={exclusionsData} currentExcl={currentExcl} renderExcl={renderRestrictions} del={handleRequestDelete} choose={chooseAutoComplete} change={changeAutoComplete} {...this.props} />
        }
    }
}

export default withExclusions;


export function prepareExclToLoad(list, isRewriteOwnerExclusions = false) {
    return isRewriteOwnerExclusions ?
        list.map(item => ({ id: item._id })) :
        list.filter(item => item.role !== 'owner').map(item => ({ id: item._id }));
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/withExclusions.js